import React from 'react'
import { DetailContent } from '../sampleDetail'

export default () => {
  return <DetailContent />
}
